export default {
  notPermittedToView: {
    en: "You are not permitted to view this page or it doesn't exists.",
    sk: 'Nemáte povolenie vidieť túto stránku alebo neexistuje.',
    cz: 'Nemáte oprávnění prohlížet tuto stránku nebo neexistuje.',
    de: 'Sie sind nicht berechtigt, diese Seite anzuzeigen, oder sie existiert nicht.',
  },
}
